module.exports = __webpack_public_path__ + "static/img/empty.314aa04e.svg";